import { render, staticRenderFns } from "./PreviewSectionsManager.vue?vue&type=template&id=55d5a3bd&"
import script from "./PreviewSectionsManager.vue?vue&type=script&lang=js&"
export * from "./PreviewSectionsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports